import { Table, Tag } from "antd";
import styled, { createGlobalStyle } from "styled-components";
export const GlobalMasterStyle = createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    .ant-layout{
        background: transparent !important;
    }
    /* A CPI field typed into while hidden (CpiMask.js useCpiStars): selected text stays unpainted too (Windows and
       Linux would paint it in the system's highlight text color); the selection shows only while the field is being
       typed in (its stars show the length then anyway), not with the window in the background */
    .cpi-stars-field::selection {
        color: transparent;
        -webkit-text-fill-color: transparent;
        background-color: transparent;
    }
    .cpi-stars-field.cpi-stars-typing::selection {
        background-color: Highlight;
    }
    /* ...and with forced colors (Windows High Contrast) its caret and the stars over it take the theme's text color,
       the stars without the backplate that would cover the caret */
    @media (forced-colors: active) {
        .cpi-stars-field {
            caret-color: CanvasText;
        }
        .cpi-stars {
            forced-color-adjust: none;
            color: CanvasText !important;
            text-shadow: 0 0 1px Canvas, 0 0 1px Canvas; /* readable on the selection highlight too */
        }
        .cpi-stars-field:disabled + .cpi-stars {
            color: GrayText !important;
        }
    }
    .ant-switch .ant-switch-inner {
        font-weight: 400 !important;
    }
    .ant-switch:not(.ant-switch-checked) .ant-switch-inner-unchecked {
        color: ${({ theme }) => theme.settings.switchOffTextColor} !important;
    }
    .appPageContainer {
        width: 100%;
        margin: 0;
    }
    @media only screen and (max-width: 991.99px) {
        .appPageContainer {
            padding: 16px 20px !important;
        }

        /* Keep viewport-height chat pages contained while preserving the same
           responsive page gutter used everywhere else. */
        .appPageContainer:has(> .insightEngine.messages-mode) {
            height: 100vh;
            height: 100dvh;
            overflow: hidden;
        }

        /* Keep every Ant Design paginator usable within responsive page widths. */
        .ant-pagination {
            width: 100%;
            max-width: 100%;
            margin: 12px 0 !important;
            padding: 0 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            flex-wrap: wrap !important;
            gap: 6px 4px !important;
        }

        .ant-pagination .ant-pagination-total-text {
            flex: 0 0 100%;
            width: 100%;
            height: auto;
            margin: 0 0 4px !important;
            text-align: center;
            line-height: 20px;
        }

        .ant-pagination > li:not(.ant-pagination-total-text):not(.ant-pagination-options) {
            margin-inline-end: 0 !important;
        }

        .ant-pagination .ant-pagination-options {
            flex: 0 0 100%;
            width: 100%;
            margin: 4px 0 0 !important;
            display: flex;
            justify-content: center;
        }
    }

    @media only screen and (max-width: 575.99px) {
        .ant-pagination .ant-pagination-item,
        .ant-pagination .ant-pagination-jump-next,
        .ant-pagination .ant-pagination-jump-prev,
        .ant-pagination .ant-pagination-prev,
        .ant-pagination .ant-pagination-next,
        .ant-pagination .ant-pagination-prev button,
        .ant-pagination .ant-pagination-next button {
            min-width: 32px;
            width: 32px;
            height: 32px;
            line-height: 32px;
        }
    }
    html {
        overflow-y: auto;
        scrollbar-gutter: stable;
    }

    html::-webkit-scrollbar {
        width: 8px;
    }

    html::-webkit-scrollbar-track {
        background: #f3f4f6;
    }

    html::-webkit-scrollbar-thumb {
        background: #c5cad3;
        border-radius: 999px;
    }

    html::-webkit-scrollbar-thumb:hover {
        background: #aeb6c2;
    }

    body{
        background: ${({ theme }) => theme.settings.whiteColor} !important;
        min-height: 100vh;
        font-family: ${({ theme }) => theme.fonts.inter} !important;
    }
    .bgWhite{
        background: ${({ theme }) => theme.settings.whiteColor} !important;
    }
    .bodyNoSidebar{
        background: #FCFCFF !important;
        height: 100vh;
        font-family: ${({ theme }) => theme.fonts.inter} !important; 
    }
`;
// new style
export const ThemeTable = styled(Table)`
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  position: relative;
  background: transparent;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 10px;
  .ant-table {
    background: transparent;
    scrollbar-color: unset !important;
    ::-webkit-scrollbar {
      width: 2px;
    }
    ::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.primary};
    }
    ::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.settings.primary};
    }

    ::-webkit-scrollbar {
      height: 2px;
      width: 2px; /* width of vertical scrollbar */
      border: 1px solid ${({ theme }) => theme.settings.primary};
    }
  }
  .ant-table-cell {
    font-style: normal;
    font-weight: 500 !important;
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    background: ${({ theme }) => theme.settings.bodyBg} !important;
    border-top: none !important;
    /* border-bottom: none !important; */
    color: ${({ theme }) => theme.settings.primary} !important;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    border-radius: 0px !important;
    a {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      color: ${({ theme }) => theme.settings.primary} !important;
      text-decoration: underline;
    }
    &:first-child {
      border-radius: 0px !important;
    }
    &:last-child {
      border-radius: 0px !important;
    }
  }
  th.ant-table-cell {
    font-weight: 500 !important;
    font-size: 12px;
    &:first-child {
      border-radius: 7px 0px 0px 0px !important;
    }
    &:last-child {
      border-radius: 0px 7px 0px 0px !important;
    }
  }
  td.ant-table-cell {
    text-transform: capitalize;
    font-weight: 400 !important;
    font-size: 12px;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    &:first-child {
      border-radius: 0px !important;
    }
    &:last-child {
      border-radius: 0px !important;
    }
  }
  tr {
    &:last-child {
      td.ant-table-cell {
        &:first-child {
          border-radius: 0px 0px 0px 0px !important;
        }
        &:last-child {
          border-radius: 0px 0px 0px 0px !important;
        }
      }
    }
  }
  .ant-table-fixed-column {
    .ant-table {
      border-radius: 15px 15px 0px 0px !important;
    }
    tr {
      &:last-child {
        td.ant-table-cell {
          &:first-child {
            border-radius: 5px !important;
          }
          &:last-child {
            border-radius: 5px !important;
          }
        }
      }
    }
  }
  ul.ant-pagination {
    margin: 0px !important;
    padding: 15px !important;
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev {
      border-radius: 5px !important;
    }
    li.ant-pagination-item,
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev,
    .ant-pagination-prev button,
    .ant-pagination-next button {
      background: ${({ theme }) => theme.settings.whiteColor} !important;
      color: ${({ theme }) => theme.settings.primary} !important;
      border-radius: 50%;
      font-weight: 600;
      font-size: 12px;
      .ant-pagination-item-ellipsis {
        font-size: 8px !important;
        color: ${({ theme }) => theme.settings.primary} !important;
      }
      &:hover,
      &.ant-pagination-item-active {
        background: ${({ theme }) => theme.settings.cta_hover} !important;
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        border-color: transparent;
        .ant-pagination-item-link-icon {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
        a {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
      }
    }
    li.ant-pagination-disabled button {
      background: transparent;
      color: ${({ theme }) => theme.settings.borderColor};
      border-radius: 50%;
      font-weight: 600;
      font-size: 13px;
      &:hover {
        background: rgba(
          ${({ theme }) => theme.settings.textColor},
          1
        ) !important;
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        border-color: ${({ theme }) => theme.settings.borderColor};
      }
    }
    .ant-select-selector {
      border-color: ${({ theme }) => theme.settings.borderColor} !important;
      font-size: 12px !important;
      line-height: 12px !important;
    }
  }
  .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.settings.borderColor} !important;
    background: ${({ theme }) => theme.settings.bodyBg} !important;
  }
  .ant-checkbox-inner {
    &:after {
      border-color: ${({ theme }) => theme.settings.borderColor} !important;
    }
  }
  .ant-checkbox-indeterminate {
    .ant-checkbox-inner {
      &:after {
        background: ${({ theme }) => theme.settings.primary} !important;
      }
    }
  }
  th.ant-table-selection-column,
  td.ant-table-selection-column {
    padding-left: 20px !important;
  }
  &.noBorders {
    border: none !important;
  }
  /* Opt-in: tighten the gap between the first (leading icon) cell and the
     second (content) cell. Only applies to tables that add this class. */
  &.tightLead {
    td.ant-table-cell:first-child {
      padding-right: 6px !important;
    }
    td.ant-table-cell:nth-child(2) {
      padding-left: 6px !important;
    }
  }

  tr.highlighted-row > td {
    background: rgba(46, 69, 218, 0.03) !important;
    border-top: 1px solid rgba(46, 69, 218, 0.5) !important;
    border-bottom: 1px solid rgba(46, 69, 218, 0.5) !important;
  }
  tr.highlighted-row > td:first-child {
    border-left: 1px solid rgba(46, 69, 218, 0.5) !important;
  }
  tr.highlighted-row > td:last-child {
    border-right: 1px solid rgba(46, 69, 218, 0.5) !important;
  }
`;
// new style
export const ThemeTag = styled(Tag)`
  border-radius: 20px !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 18px !important;
  .ant-tag-close-icon {
    font-size: 12px !important;
    color: ${({ theme }) => theme.settings.primary} !important;
  }
`;
